import { Info } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgInformationCircle = mkIcon(Info);